import { useEffect } from 'react';
import { useFieldArray } from 'react-hook-form';

import { Grid, IconButton, Stack } from '@mui/material';

import { IcDeleteTrash } from '@/assets/images';
import { RenderFormField } from '@/components';
import { Button } from '@/components/TailwindComponents';
import { colors } from '@/theme/variables';

import { socialMediaFormFields } from './data';

export const SocialMediaForm = ({
  disabled = false,
}: {
  disabled?: boolean;
}) => {
  const { remove, append, fields } = useFieldArray({
    name: 'socialMedia',
  });

  useEffect(() => {
    if (fields.length === 0) {
      append(
        {
          username: '',
          platform: '',
        },
        { shouldFocus: false },
      );
    }
  }, [fields]);

  const handleAddSocialMedia = () => {
    append({
      username: '',
      platform: '',
    });
  };

  return (
    <Stack my={2}>
      {fields.map((socialMediaField, index: number) => (
        <Grid
          container
          columnSpacing={2}
          key={`row-${socialMediaField?.id}-${index}`}
        >
          {socialMediaFormFields.map((field, idx) => (
            <Grid key={`${socialMediaField?.id}-${idx}`} xs={3} item>
              <RenderFormField
                {...field}
                name={`socialMedia.${index}.${field.name}`}
                disabled={disabled}
              />
            </Grid>
          ))}
          <Grid style={{ display: 'flex' }} xs={3} item>
            <IconButton
              onClick={() => remove(index)}
              disabled={disabled}
              sx={{ color: colors.error.main, mt: 2, alignSelf: 'center' }}
            >
              <IcDeleteTrash />
            </IconButton>
          </Grid>
        </Grid>
      ))}
      <Button
        color="error"
        type="button"
        size="sm"
        variant="secondary"
        className="w-fit text-sm"
        onClick={handleAddSocialMedia}
        disabled={disabled}
      >
        + Add social media
      </Button>
    </Stack>
  );
};
